import _defineProperty from "E:/code/jinhua-step-two/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, Vue } from "vue-property-decorator";
import { getLineData } from "@/api/api";
let LineList = class LineList extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "line_data", []);

    _defineProperty(this, "base_url", process.env.VUE_APP_BASE_URL);
  }

  async created() {
    const senic_data = JSON.parse(sessionStorage.getItem("scenic_data"));
    const res = await getLineData(senic_data.id);
    this.line_data = res.data;
  } // 点击某个路线


  openLineDetail(item) {
    this.$router.push({
      name: "scenic",
      query: { ...this.$route.query
      },
      params: {
        line_id: item.id
      }
    });
  } // 返回景区页面


  back() {
    this.$router.back();
  }

};
LineList = __decorate([Component], LineList);
export default LineList;